module.exports = __webpack_public_path__ + "static/media/img_bot@2x.e71ef3e0.jpg";